import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const RightYAxis = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="RightYAxis"
    {...props}
  >
    <rect width={1.33333} height={12} transform="matrix(-1 0 0 1 13.3359 2)" fill="#394959" />
    <rect width={2} height={1.33333} transform="matrix(-1 0 0 1 10.6719 12.666)" fill="#394959" />
    <rect width={2} height={1.33333} transform="matrix(-1 0 0 1 7.33594 12.666)" fill="#394959" />
    <rect width={2} height={1.33333} transform="matrix(-1 0 0 1 4 12.666)" fill="#394959" />
    <path
      d="M9.99902 5.33398H8.39072L7.35311 7.50065H7.3116L6.27399 5.33398H4.66569L6.6164 8.99023V10.6673H8.04831V8.99023L9.99902 5.33398Z"
      fill="#394959"
    />
  </svg>
);
export default React.memo(RightYAxis);
